




import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import GetUserName from '../../components/Membership/GetUserName.vue'

@Component({
  components: {
    GetUserName
  }
})
export default class UserName extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }
}
